export default __webpack_public_path__ + "static/media/logo-inline.d806c9e5.svg";